<script setup lang="ts">
import MdiIcon from '@/components/MdiIcon.vue'

withDefaults(
  defineProps<{
    path: string
    title: string
    size?: string | number
    iconColor?: string
  }>(),
  {
    size: 50,
    iconColor: 'currentColor',
  }
)

defineEmits<{
  click: []
}>()
</script>

<template>
  <button type="button" class="run-btn toolbar-btn" :title="title" @click="$emit('click')">
    <MdiIcon :path="path" :size="size" :color="iconColor" />
  </button>
</template>

<style scoped>
.run-btn {
  display: flex;
  align-items: center;
  height: auto;
  padding: 4px;
  border: none;
  border-radius: var(--radius-standard, 8px);
  cursor: pointer;
  background: transparent;
  transition: all 0.15s ease;
}

.run-btn:hover {
  filter: brightness(1.15);
  box-shadow: var(--shadow-sm);
  background: var(--hover-bg);
}

.run-btn:active {
  transform: scale(0.95);
  background: var(--active-bg);
}

.toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-standard, 8px);
  cursor: pointer;
  background: transparent;
  transition: all 0.15s ease;
}

.toolbar-btn:hover {
  background: var(--hover-bg);
}

.toolbar-btn:active {
  transform: scale(0.95);
}
</style>
